var React = require('react');

function SearchMinus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M208 80a128 128 0 1 1-90.51 37.49A127.15 127.15 0 0 1 208 80m0-80C93.12 0 0 93.12 0 208s93.12 208 208 208 208-93.12 208-208S322.88 0 208 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M292 180H124a12 12 0 0 0-12 12v32a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12v-32a12 12 0 0 0-12-12zm213 262.7L405.3 343a24 24 0 0 0-17-7H372l-36 36v16.3a24 24 0 0 0 7 17l99.7 99.7a23.9 23.9 0 0 0 33.9 0l28.3-28.3a24.11 24.11 0 0 0 .1-34z","className":"fa-primary","key":2})]);
}

SearchMinus.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = SearchMinus;

SearchMinus.default = SearchMinus;
